// removed by extract-text-webpack-plugin
module.exports = {"narrowMax":"1000","wideMax":"Infinity","narrow":"narrow","wide":"wide"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/app_prihum_sdnt.scss
// module id = 7Cai
// module chunks = 6